// src/Layout/menuConfig.js

import InsertChartIcon from "@material-ui/icons/InsertChart";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import StoreIcon from "@material-ui/icons/Store";
import CategoryIcon from "@material-ui/icons/Category";
import StarsIcon from "@material-ui/icons/Stars";
import PanoramaFishEyeIcon from "@material-ui/icons/PanoramaFishEye";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import SettingsIcon from "@material-ui/icons/Settings";
import BusinessIcon from "@material-ui/icons/Business";
import BuildIcon from "@material-ui/icons/Build";

export const MENU_STRUCTURE = [
  // DASHBOARD
  {
    key: "dashboard",
    label: "Dashboard",
    icon: InsertChartIcon,
    items: [
      { label: "Home", to: "/" },
      { label: "Website", to: "/dashboard/site" },
      { label: "Application", to: "/dashboard/application" },
    ],
  },

  // ADMIN
  {
    key: "admin",
    label: "Admin",
    icon: SupervisorAccountIcon,
    items: [
      { label: "Users", to: "/users" },
      { label: "Roles", to: "/roles" },
    ],
  },

  // STORE MANAGEMENT
  {
    key: "store",
    label: "Store Management",
    icon: StoreIcon,
    items: [
      { label: "Accounts", to: "/accounts" },
      { label: "Stores", to: "/stores" },
      { label: "Builder Platform", to: "/builder-platform" },
      { label: "Store Locations", to: "/store-locations" },
      { label: "Screensaver", to: "/screensaver" },
    ],
  },

  // CATALOG
  {
    key: "catalog",
    label: "Catalog",
    icon: CategoryIcon,
    show: (p) =>
      p.includes("view_categories") ||
      p.includes("view_products") ||
      p.includes("view_dynamic-products"),
    items: [
      {
        label: "Parent Categories",
        to: "/parent-categories",
        show: (p) => p.includes("view_categories"),
      },
      {
        label: "Categories",
        to: "/categories",
        show: (p) => p.includes("view_categories"),
      },
      {
        label: "Static Products",
        to: "/products",
        show: (p) => p.includes("view_products"),
      },
      {
        label: "Dynamic Products",
        to: "/dynamic/products",
        show: (p) => p.includes("view_dynamic-products"),
      },
      {
        label: "Best Sellers",
        to: "/bestsellers"
      },
      {
        label: "Non Confirming Rings",
        to: "/nc-rings"
      },
      {
        label: "Import / Export",
        to: "/bulk-products",
        show: (p) => p.includes("view_import_export"),
      },
    ],
  },

  // SIGNET DATA
  {
    key: "signet",
    label: "Signet Data",
    icon: StarsIcon,
    show: (p) => p.includes("view_signet_data"),
    items: [
      { label: "Shape", to: "/signet-shape" },
      { label: "Size", to: "/signet-size" },
      { label: "Shank", to: "/shank" },
      { label: "Cerakote Color", to: "/cerakote-color" },
      { label: "School", to: "/schools" },
      { label: "School Cerakote Color", to: "/school-cerakote-colors" },
      { label: "Signet Rings", to: "/ring-data" },
      { label: "Signet Engraving", to: "/signet-engravings" },
      { label: "Signet Pricing", to: "/signet-pricing" },
      { label: "Signet Inlay", to: "/signet-inlay" },
      { label: "Signet Studio", to: "/signet-studio" },
    ],
  },

  // BAND DATA
  {
    key: "band",
    label: "Band Data",
    icon: PanoramaFishEyeIcon,
    show: (p) =>
      p.includes("view_categories") ||
      p.includes("view_products") ||
      p.includes("view_dynamic-products"),
    items: [
      {
        label: "Collegiate Engravings",
        to: "/collegiate-engravings",
      },
      {
        label: "Design Pattern Studio",
        to: "/design-pattern-studio",
      },
      {
        label: "Edit Band Config",
        to: "/design-pattern-studio/edit-config",
      },
      {
        label: "Precious Pricing",
        to: "/precious-price",
        show: (p) => p.includes("view_import_export"),
      },
    ],
  },

  // ORDERS
  {
    key: "orders",
    label: "Orders",
    icon: ShoppingBasketIcon,
    show: (p) => p.includes("view_orders"),
    items: [
      {
        label: "Direct Orders",
        to: "/direct/orders",
      },
      {
        label: "Store Orders",
        to: "/store/orders",
      },
    ],
  },

  // CONFIGURATION
  {
    key: "configuration",
    label: "Configuration",
    icon: SettingsIcon,
    items: [
      {
        label: "Info Modal Data",
        to: "/material-data"
      },
      {
        label: "Material Sort Order",
        to: "/sort-order"
      },
      {
        label: "Store Shipping",
        to: "/account/shipping",
        show: (p) => p.includes("view_shipping"),
      },
      {
        label: "Guest Shipping",
        to: "/shipping",
        show: (p) => p.includes("view_shipping"),
      },
    ],
  },

  // NETSUITE CONFIG
  {
    key: "netsuite",
    label: "Netsuite Config",
    icon: BusinessIcon,
    items: [
      { label: "Inlay", to: "/netsuite/inlay" },
      { label: "Sleeve", to: "/netsuite/sleeve" },
      { label: "Design Pattern", to: "/netsuite/design-pattern" },
      { label: "Ring Finish", to: "/netsuite/ring-finish" },
      { label: "Inlay Finish", to: "/netsuite/inlay-finish" },
      { label: "Bulk Upload", to: "/bulk-upload" },
    ],
  },

  // TOOLS
  {
    key: "tools",
    label: "Tools",
    icon: BuildIcon,
    items: [
      {
        label: "Precious Pricing Calculator",
        to: "/precious-pricing-calculator",
        show: (p) => p.includes("view_import_export"),
      },
      {
        label: "Price Scraper",
        to: "/export-product-price",
        show: (p) => p.includes("view_import_export"),
      },
    ],
  },
];